import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

export const createSupabase = (url: string, key: string) => 
  createClient<Database>(url, key, {
    auth: {
      persistSession: true, // Required for browsers
      autoRefreshToken: true,
    }
  });

export type { Database } from './types';
export * from './types';